import axios from 'axios';

export const postContactUs = async (requestData) => {
  return await axios.post('/api/public/contact_us/', requestData);
};
